import { render, staticRenderFns } from "./StandaloneMenuBar.vue?vue&type=template&id=688ff72c&scoped=true"
import script from "./StandaloneMenuBar.vue?vue&type=script&lang=js"
export * from "./StandaloneMenuBar.vue?vue&type=script&lang=js"
import style0 from "./StandaloneMenuBar.vue?vue&type=style&index=0&id=688ff72c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688ff72c",
  null
  
)

export default component.exports